import React from "react";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Input } from "@remo-co/ui-core/src/components/Input";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import copy from "copy-to-clipboard";
import "./CopyEventUrl.scss";
import { useI18n } from "i18n";
import { getInviteUrl } from "helpers/urlHelper";
import { IEvent } from "../../types";
import { useStyles } from "./styles";

interface Props {
  event: IEvent;
  copyLinkId: string;
}

const CopyEventUrl = ({ event, copyLinkId }: Props) => {
  const [inviteLink, setInviteLink] = React.useState("");
  const { addSuccessNotification } = useNotificationActions();
  const { t } = useI18n(["common", "event"]);
  const styles = useStyles();

  React.useEffect(() => {
    const updateInviteURL = async () => {
      const inviteUrl = getInviteUrl(event);

      setInviteLink(inviteUrl);
    };

    if (event) {
      updateInviteURL();
    }
  }, [event]);
  const handleCopyInviteLink = () => {
    copy(inviteLink);
    addSuccessNotification({
      message: t("event:copied.link"),
      autoDismiss: 5,
    });
  };

  return (
    <Container flex>
      <Container style={{ flex: 1 }} right="xs">
        <Input value={inviteLink} readOnly fullWidth size="sm" />
      </Container>
      <Typography
        component="button"
        variant="button"
        id={copyLinkId}
        onClick={handleCopyInviteLink}
        className={styles.copyLinkButton}
      >
        {t("event:link.button")}
      </Typography>
    </Container>
  );
};

export default CopyEventUrl;
